const SET_TICKET_DATA = 'SET_TICKET_DATA'
const SET_TICKET_REFER_FORM = 'SET_TICKET_REFER_FORM'
const SET_QUOTE_CASE = 'SET_QUOTE_CASE'
const SET_REFER_DATA = 'SET_REFER_DATA'
const SET_REFRESH_PAGE = 'SET_REFRESH_PAGE'

const state = {
  ticketData: null,
  ticketReferForm: null,
  quoteCase: [],
  referData: null,
  refreshPage: 0
}

const mutations = {
  [SET_TICKET_DATA]: (state, value) => {
    state.ticketData = value
  },
  [SET_TICKET_REFER_FORM]: (state, value) => {
    state.ticketReferForm = value
  },
  [SET_QUOTE_CASE]: (state, value) => {
    state.quoteCase = value
  },
  [SET_REFER_DATA]: (state, value) => {
    state.referData = value
  },
  [SET_REFRESH_PAGE]: (state, value) => {
    state.refreshPage = value
  }
}

const actions = {
  setTicketData({ commit }, val) {
    commit(SET_TICKET_DATA, val)
  },
  setTicketReferForm({ commit }, val) {
    commit(SET_TICKET_REFER_FORM, val)
  },
  setQuoteCase({ commit }, val) {
    commit(SET_QUOTE_CASE, val)
  },
  setReferData({ commit }, val) {
    commit(SET_REFER_DATA, val)
  },
  setRefreshPage({ commit }, val) {
    commit(SET_REFRESH_PAGE, val)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}